import { Reveal } from "./Reveal";
import { Heart, Mail, ArrowRight } from "lucide-react";

const FOUNDER_EMAIL = "thequarterlypulse@gmail.com";

export const Founder = () => (
  <section id="founder" data-testid="founder-section" className="py-28 lg:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="order-2 lg:order-1 lg:col-span-7">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-terracotta">
            A note from our founder
          </p>
          <h2 className="mt-6 font-serif text-4xl font-medium italic leading-tight tracking-tight text-walnut sm:text-5xl">
            Hey there, I&rsquo;m Anthony.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-umber/90 md:text-lg">
            <p>
              Not long ago, I noticed how quickly all-hands energy fades. Leaders
              spend hours on the deck, the meeting lands well — and 48 hours
              later the decisions are fuzzy, half the team missed it, and the
              momentum is gone.
            </p>
            <p>
              I started The Quarterly Pulse to help teams act on what was
              actually said. We turn your all-hands deck or transcript into a
              recap email, Slack-ready highlights, and a clear list of decisions
              and next steps — and you review and approve everything before it
              goes to your team.
            </p>
            <p className="font-medium text-walnut">
              Thanks for stopping by. I&rsquo;d love to help your team&rsquo;s
              next all-hands last beyond the meeting.
            </p>
          </div>
          <p className="mt-10 flex items-center gap-3" data-testid="founder-name">
            <Heart className="h-4 w-4 text-terracotta" />
            <span className="font-serif text-2xl italic text-terracotta">Anthony Coston</span>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-clay">
              — Founder, The Quarterly Pulse
            </span>
          </p>
          <a
            data-testid="founder-contact-button"
            href={`mailto:${FOUNDER_EMAIL}`}
            className="group mt-8 inline-flex items-center gap-2.5 rounded-full border border-walnut/30 px-6 py-3.5 text-sm font-semibold text-walnut transition-colors duration-300 hover:border-walnut hover:bg-walnut hover:text-paper"
          >
            <Mail className="h-4 w-4" />
            Write to Anthony directly
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>

      <Reveal className="order-1 lg:order-2 lg:col-span-5" delay={0.1}>
        <div className="relative mx-auto max-w-sm">
          <div className="overflow-hidden rounded-t-[2rem] rounded-b-[999px] border border-walnut/15 shadow-[0_24px_60px_rgba(42,32,28,0.18)]">
            <img
              src="/founder.jpg"
              alt="Anthony Coston, Founder of The Quarterly Pulse"
              data-testid="founder-photo"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
          <span className="absolute -left-5 bottom-16 flex items-center gap-2 rounded-full border border-line bg-paper px-4 py-2.5 shadow-[0_12px_30px_rgba(42,32,28,0.12)]">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-walnut">
              Real person. Replies fast.
            </span>
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
